<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" id="labelButtons">Notification Center</h4>
</div>

<ng-template #notificationsTemplate let-showType="showType">
    <my-notifications *ngIf="showType === 'my-notifications'"></my-notifications>
    <create-notification *ngIf="showType === 'create-notification' && auth.hasSecurityTransactionClaim(securityTransactionTypeEnum.CreateNotification)"></create-notification>
</ng-template>

<mvm-tab [data]="tabData" [contentTemplate]="notificationsTemplate" [selectedTab]="0"></mvm-tab>
